import axios from 'axios';
// 逻辑链
// 检测阶段：插件轮询 -> 发现新版本 -> 停止轮询（节省资源，防止干扰）。
// 强提示阶段：弹出对话框（Modal） -> 用户点“稍后”。
// 弱提示阶段（关键）：
// 对话框消失。
// 右下角立即出现一个小通知框。
// 该通知框没有关闭按钮，一直悬浮，直到用户点击刷新。

interface VersionData {
  version: number | string;
}

interface UpdaterOptions {
  timer?: number;
  jsonUrl?: string;
}

export class AutoUpdater {
  private oldVersion: string | number | null = null;
  private timer: NodeJS.Timeout | null = null;
  private interval: number;
  private jsonUrl: string;
  private onUpdateCallback: ((data: VersionData) => void) | null = null;
  private isChecking = false; // 请求锁

  constructor(options: UpdaterOptions = {}) {
    this.interval = options.timer || 60 * 1000; // 默认1分钟
    this.jsonUrl = options.jsonUrl || '/version.json';
    this.init();
  }

  private async init() {
    try {
      const data = await this.fetchVersion();
      this.oldVersion = data.version;
      // 初始化拿到版本号后，开始轮询
      this.startPolling();
    } catch (e) {
      console.warn('[Updater] Init failed (dev env?):', e);
    }
  }

  private async fetchVersion(): Promise<VersionData> {
    // 添加时间戳防止缓存
    const { data } = await axios.get<VersionData>(`${this.jsonUrl}?t=${Date.now()}`);
    return data;
  }

  private async checkUpdate() {
    if (this.isChecking) return;
    this.isChecking = true;

    try {
      const newVersionData = await this.fetchVersion();
      
      // 只要新旧版本标识不一致，就是有更新
      if (this.oldVersion && newVersionData.version !== this.oldVersion) {
        // 彻底停止轮询（防止后续版本重复弹窗，因为用户已经知道需要刷新了）
        this.stopPolling();
        
        // 触发回调
        if (this.onUpdateCallback) {
          this.onUpdateCallback(newVersionData);
        }
      }
    } catch (error) {
      // 网络错误忽略
    } finally {
      this.isChecking = false;
    }
  }

  private visibilityHandler = () => {
    if (document.visibilityState === 'visible') {
      this.checkUpdate();
    }
  };

  private startPolling() {
    this.stopPolling();
    // 具名函数引用，方便后续 remove
    this.timer = setInterval(this.visibilityHandler, this.interval);
    document.addEventListener('visibilitychange', this.visibilityHandler);
  }

  public stopPolling() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  public onUpdate(fn: (data: VersionData) => void) {
    this.onUpdateCallback = fn;
  }

  public destroy() {
    this.stopPolling();
    // 2. 移除事件监听
    document.removeEventListener('visibilitychange', this.visibilityHandler);
  }

}